import { i18next } from "@translations/up/i18next";
import { Field } from "formik";
import _get from "lodash/get";
import PropTypes from "prop-types";
import React from "react";
import { FieldLabel, RemoteSelectField } from "react-invenio-forms";

export const ResourceTypeDescriptionFieldCmp = ({
  fieldPath,
  record,
  label,
  labelIcon,
  required,
  multiple,
  placeholder,
  clearable,
  formik,
}) => {
  const resourceType = formik.form.values.metadata.resource_type;

  const serializeSuggestions = (suggestions) =>
    Array.isArray(suggestions)
      ? suggestions.map((item) => ({
          text: item.title_l10n,
          value: item.id,
          key: item.id,
        }))
      : [
          {
            text: suggestions.title_l10n,
            value: suggestions.id,
            key: suggestions.id,
          },
        ];

  const fieldLabel = (
    <FieldLabel
      htmlFor={fieldPath}
      icon={labelIcon}
      label={label}
      required={required}
    />
  );

  return (
    <RemoteSelectField
      fieldPath={fieldPath}
      disabled={!Boolean(resourceType)}
      suggestionAPIUrl="/api/vocabularies/resourcetypedescriptions"
      suggestionAPIHeaders={{
        Accept: "application/vnd.inveniordm.v1+json",
      }}
      suggestionAPIQueryParams={{ tags: resourceType }}
      placeholder={placeholder}
      required={required}
      clearable={clearable}
      multiple={multiple}
      initialSuggestions={_get(
        record,
        "ui.custom_fields.resource_type_description",
        []
      )}
      label={fieldLabel}
      noQueryMessage={i18next.t("Search for resource type descriptions...")}
      serializeSuggestions={serializeSuggestions}
      helpText={
        Boolean(resourceType)
          ? i18next.t("Single term to add some detail to the resource type, it might be empty.")
          : i18next.t("Please select a resource type first.")
      }
    />
  );
};

ResourceTypeDescriptionFieldCmp.propTypes = {
  fieldPath: PropTypes.string.isRequired,
  record: PropTypes.object.isRequired,
  label: PropTypes.string,
  labelIcon: PropTypes.string,
  required: PropTypes.bool,
  multiple: PropTypes.bool,
  clearable: PropTypes.bool,
  placeholder: PropTypes.string,
  formik: PropTypes.object.isRequired,
};

ResourceTypeDescriptionFieldCmp.defaultProps = {
  label: i18next.t("Resource type description"),
  labelIcon: "tag",
  multiple: false,
  clearable: true,
  placeholder: i18next.t("A single term to add some detail to the resource type."),
  required: false,
};

export const ResourceTypeDescriptionField = (props) => {
  return (
    <Field>
      {(formik) => <ResourceTypeDescriptionFieldCmp formik={formik} {...props} />}
    </Field>
  );
};

ResourceTypeDescriptionField.propTypes = {
  fieldPath: PropTypes.string.isRequired,
  record: PropTypes.object.isRequired,
  label: PropTypes.string,
  labelIcon: PropTypes.string,
  required: PropTypes.bool,
  multiple: PropTypes.bool,
  clearable: PropTypes.bool,
  placeholder: PropTypes.string,
};

ResourceTypeDescriptionField.defaultProps = {
  label: i18next.t("Resource type description"),
  labelIcon: "tag",
  multiple: false,
  clearable: true,
  placeholder: i18next.t("A single term to add some detail to the resource type."),
  required: false,
};
